import { useContext, useState } from 'react'
import { useHookForm } from 'src/hooks'
import { RootContext } from 'context/rootContext'
import { validationSchema } from './schema'
import { sendKeyCode } from 'services/registerService'
import { editUserData } from 'services/userService'
import { DEFAULT_VALUES } from './constants'
import MODAL from '../../../utils/modals'

const useConfirmAccount = () => {
  const [error, setError] = useState(false)
  const context = useContext(RootContext)

  const onSubmitForm = async (values, params) => {
    const { keyCode } = values
    const { credentials } = context
    const { email, password, authenticationToken, firstName, lastName, phone, document, birthDate, isMktsrvTermsAccepted, isNewsletterOptIn, successCallback } = params
    const usePassword = password || credentials.password
    context.showLoader()
    setError(false)
    try {
      const { status } = await sendKeyCode({ keyCode, isNewsletterOptIn, email, password: usePassword, authenticationToken })
      if (status >= 400) {
        setError(true)
      } else {
        const userData = { firstName, lastName, phone, document, birthDate, isMktsrvTermsAccepted, isNewsletterOptIn }
        await editUserData(userData)
        if (successCallback) successCallback()
        context.toggleWarningModal({
          ...MODAL.ACCOUNT_CREATE_SUCCESS(),
          visible: true,
          onConfirm: () => {
            context.toggleWarningModal({ visible: false })
          }
        })
        await context.getProfile()
      }
    } catch (err) {
      setError(true)
      console.error(err)
    } finally {
      context.hideLoader()
    }
  }

  const form = useHookForm({
    onSubmitForm,
    validationSchema,
    defaultValues: DEFAULT_VALUES
  })

  return { form, error }
}

export default useConfirmAccount
